import {
  BarChart3,
  Database,
  FilePlus2,
  Gauge,
  KeyRound,
  ListTodo,
  MoonStar,
  Pencil,
  Play,
  Search,
  Sparkles,
  Wrench,
} from "lucide-react";

import { getToolDisplayInfo } from "../../toolConfig";
import { isScorecardVisualType, resolveEntityTypeFromToolType } from "../../utils/toolVisual";

import EntityIcon from "@/components/ui/icons/EntityIcon";
import { RequestLog, Trace } from "@/components/ui/icons";
import { cn } from "@/lib/utils";

type ToolDisplayType = ReturnType<typeof getToolDisplayInfo>["type"];

export const ToolIcon = ({
  type,
  isAnimated = false,
  className,
}: {
  type: ToolDisplayType;
  isAnimated?: boolean;
  className?: string;
}) => {
  const iconClassName = cn(
    "h-3.5 w-3.5 flex-shrink-0",
    isAnimated ? "text-blue-500" : "text-gray-400",
    className,
  );

  if (isScorecardVisualType(type)) {
    return <Gauge className={cn(iconClassName, isAnimated && "animate-pulse")} />;
  }

  const entityType = resolveEntityTypeFromToolType(type);
  if (entityType) {
    return (
      <EntityIcon
        type={entityType}
        size="xs"
        className={cn(iconClassName, isAnimated && "animate-pulse")}
      />
    );
  }

  if (type === "trace") {
    return <Trace className={cn(iconClassName, isAnimated && "animate-pulse")} />;
  }

  if (type === "request_log") {
    return <RequestLog className={cn(iconClassName, isAnimated && "animate-pulse")} />;
  }

  const icons = {
    planning: ListTodo,
    running: Play,
    fetching: Database,
    finalizing: Sparkles,
    updating: Pencil,
    model: Sparkles,
    search: Search,
    creating: FilePlus2,
    sleeping: MoonStar,
    analytics: BarChart3,
    env_var: KeyRound,
    unknown: Wrench,
  } as const;

  const Icon = icons[type as keyof typeof icons] ?? Wrench;
  return <Icon className={cn(iconClassName, isAnimated && "animate-pulse")} />;
};
